import React, {Component} from 'react'
import CSSModules from 'react-css-modules'
import styles from './inputProfile.css'

const iconsName = [
  'ico-book',
  'ico-flag',
  'ico-price',
  'ico-rocket'
]
class InputProfile extends Component {
  onClickIcon(icon) {
    const { input } = this.props
    input.onChange(icon)
  }

  render() {
    const { input, placeholder, type, meta: { touched, error } } = this.props

    const icons = iconsName.map(icon => {
      return (
        <div key={icon} onClick={this.onClickIcon.bind(this, icon)} className={styles.iconBoxItem}>
          <svg className={'svg-icon'}>
            <use xlinkHref={'#' + icon}/>
          </svg>
        </div>
      )
    })

    return (
      <div className={touched && error ? styles.inputBoxError : styles.inputBox}>
        {input.name === 'customIcon' ? <div className={styles.iconBox}>{icons}</div> : ''}

        <input {...input} type={type || 'text'} placeholder={placeholder} className={styles.inputField} onFocus={e => {

          e.target.placeholder = ''
        }} onBlur={e => {
          e.target.placeholder = placeholder
        }}/>

        {touched && error && <p className={styles.inputAlert}>{error}</p>}
      </div>
    )
  }
}
export default CSSModules(InputProfile, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit2/InputProfile.js